<template>
     <vs-dialog v-model="active" prevent-close width="700px" @close="cancelarClonacion">
        <template #header>
          <h4 class="not-margin">
            Clonar código de sesión de un ciclo escolar a otro
          </h4>
        </template>
        <div class="center content-inputs">
            <vs-alert warn v-if="errorClonar" class="mb-3">
                <template #title>
                    {{errorMessage}}
                </template>
            </vs-alert>
            <form autocomplete="off" @submit.prevent="postClonarCodigosSesion()">
                <vs-row>
                    <vs-col w="5">
                        <h6><strong>Código de sesión a clonar</strong></h6>
                        <md-divider></md-divider>
                        <p class="mt-2 mb-2">Deberá seleccionar la institución y ciclo escolar que desea clonar.</p>
                        <vs-row>
                            <vs-col w="12" class="mt-1">
                                <label><small>INSTITUCIÓN</small></label>
                                <vs-select block filter placeholder="Institución" v-model="institucion" v-if="listInstituciones.length" class="pt-0 pl-0" @input="getCiclosEscolares()">
                                    <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id" >
                                        {{option.text}}
                                    </vs-option>
                                </vs-select>
                            </vs-col>
                            <vs-col w="12" class="mt-1">
                                <label><small>CICLO ESCOLAR</small></label>
                                <vs-select :loading="loadingCiclo" block filter placeholder="Ciclo escolar" v-model="ciclo_escolar_origen_id" :disabled="!listCiclos.length" class="pt-0 pl-0" :key="listCiclosId">
                                    <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </vs-select>
                            </vs-col>
                            <vs-col w="12">
                                <vs-checkbox v-model="clonar_horarios">
                                    Clonar los horarios
                                </vs-checkbox>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col w="2">
                        <div>
                            <p style="font-size: 1.5rem; text-align: center;"><i class="fas fa-long-arrow-alt-right"></i></p>
                        </div>
                    </vs-col>
                    <vs-col w="5">
                        <h6><strong>Clonar código de sesión en</strong></h6>
                        <md-divider></md-divider>
                        <p class="mt-2 mb-2">Deberá seleccionar el ciclo escolar destino.</p>
                        <vs-row>
                            <vs-col w="12" class="mt-1">
                                <label><small>CICLO ESCOLAR</small></label>
                                <vs-select :loading="loadingCiclo" block filter placeholder="Ciclo escolar" v-model="ciclo_escolar_destino_id " :disabled="getDisable(listCiclos)" class="pt-0 pl-0" :key="listCiclosId">
                                    <vs-option v-for="option in getListCiclos(listCiclos)"  :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </vs-select>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col w="12" class="mt-4 d-flex">
                        <div @click="cancelarClonacion()">
                            <div class="botonCancelar">
                                Cancelar
                            </div>
                        </div>
                        <vs-button
                            success
                            type="submit"
                            class="ml-auto"
                        >
                            Guardar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </vs-dialog>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
export default {
    props:[
        'value',
        'listInstituciones'
    ],
    data () {
        return {
            active: false,
            institucion: '',
            listCiclosId: (new Date()).getTime(),
            loadingCiclo: false,
            ciclo_escolar_origen_id: '',
            ciclo_escolar_destino_id : '',
            listCiclos: [],
            listCiclosId: (new Date()).getTime(),
            clonar_horarios: false,
            errorClonar: false,
            errorMessage: ''
        }
    },
    methods: {
        getDisable(listCiclos){
            if(!listCiclos.length || this.ciclo_escolar_origen_id == ''){
                return true
            }
            return false
        },
        getListCiclos(listCiclos){
            const ciclo = listCiclos.filter(ciclo => ciclo.id != this.ciclo_escolar_origen_id)
            return ciclo
        },
        async getCiclosEscolares () {
            if (this.institucion) {
                try {
                    this.loadingCiclo = true
                    const { data: ciclosEsc } = await catalogos.getCiclosEscolares(this.institucion)
                    this.listCiclos = ciclosEsc
                    this.listCiclosId = (new Date()).getTime()
                    this.loadingCiclo = false
                } catch (error) {
                    console.log(error)
                }
            }   
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion){
                this.errorFields.push('institucion')
            }
            if (!this.ciclo_escolar_origen_id){
                this.errorFields.push('ciclo_escolar_origen_id')
            }
            if (!this.ciclo_escolar_destino_id){
                this.errorFields.push('ciclo_escolar_destino_id')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postClonarCodigosSesion(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    this.errorClonar = false
                    const formData = new FormData()
                    formData.append("institucion_id",this.institucion)
                    formData.append("ciclo_escolar_origen_id",this.ciclo_escolar_origen_id)
                    formData.append("ciclo_escolar_destino_id",this.ciclo_escolar_destino_id)
                    formData.append("clonar_horarios",this.clonar_horarios)
                    const {data: response} = await catalogos.postClonarCodigosSesion(formData)
                    this.$vs.notification({
                        progress: 'auto',
                        duration: '10000',
                        color: 'success',
                        progress: 'auto',
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    this.cancelarClonacion()
                    loading.close()
                }catch(error){
                    this.errorClonar = true
                    this.errorMessage = error.response.data.message
                    this.institucion = ''
                    this.ciclo_escolar_origen_id = ''
                    this.ciclo_escolar_destino_id = ''
                    this.clonar_horarios = false
                    loading.close()
                }
            }
        },
        cancelarClonacion(){
            this.institucion = ''
            this.ciclo_escolar_origen_id = ''
            this.ciclo_escolar_destino_id = ''
            this.clonar_horarios = false
            this.active = false,
            this.errorClonar = false
            this.errorMessage = ''
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>